import { Link, useLocation } from 'react-router-dom';

const NavLink = ({ to, children, className }: { to: string; children: React.ReactNode, className: string }) => {
  const location = useLocation();

  const isActive =
    to === '/'
      ? location.pathname === '/'
      : location.pathname.startsWith(to);

  return (
    <Link
      to={to}
      className={`relative text-gray-700 hover:!text-[#fe7f1f] font-medium pb-1 group ${className} ${
        isActive ? '!text-[#fe7f1f]' : ''
      }`}
    >
      {children}
      <span
        className={`absolute bottom-0 left-0 h-0.5 bg-highlight transition-all duration-300 ease-in-out group-hover:w-full ${
          isActive ? 'w-full' : 'w-0'
        }`}
      ></span>
    </Link>
  );
};

export default NavLink;
